<template>
    <b-card no-body class="overflow-hidden">
        <b-row>
            <b-col class="m-2">
                <div class="user-img">
                    <b-img
                        rounded 
                        src="https://eitrawmaterials.eu/wp-content/uploads/2016/09/person-icon.png" 
                        width="60" 
                        height="60"
                        
                    />
                </div>
                <div class="user-details">
                    <div>
                        <b-link class="text-success font-weight-bold">Catsi C.</b-link>
                    </div>
                    <div>
                        Wrote a review
                    </div>
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-img
                    class="image1"
                    src="https://i.imgur.com/WpFuCvl.jpg"
                />
            </b-col>
        </b-row>
        <b-row class="m-2 text-success font-weight-bold">
            <b-col>
                Batala Bar
                <hr class="separator">
            </b-col>
        </b-row>
        <b-row class="mx-2">
            <b-col>
                <Star
                    :rating="4.5"
                    :fontScale=1
                    :readOnly=true
                />
            </b-col>
        </b-row>
        <b-row class="mx-2">
            <b-col>
                <div class="w-100">
                    Quiant cafe and bar across San Agustin Church. They serve the best coffee float in the area and local craft beers. The second floor gives a view of central of Casa Manila. There is a wide selection of
                </div>
                <div>
                    <b-link class="text-success">Continue Reading</b-link>
                </div>
                <hr class="separator">
            </b-col>
        </b-row>
        <b-row class="mx-2 my-2">
            <b-col>
                <div class="text-muted" style="width: 100%; overflow: hidden;">
                    <div class="mr-3" style="float: left;" v-b-tooltip.hover title="Useful">
                        <b-icon icon="exclamation-circle" /><span class="ml-2">1</span>
                    </div>
                    <div class="mr-3" style="float: left;" v-b-tooltip.hover title="Funny">
                        <b-icon icon="emoji-laughing" /><span class="ml-2">1</span>
                    </div>
                    <div class="mr-3" style="float: left;" v-b-tooltip.hover title="Cool">
                        <b-icon icon="emoji-sunglasses" /><span class="ml-2">1</span>
                    </div>
                </div>
            </b-col>
        </b-row>
    </b-card>
</template>

<style scoped>
.image1 {
    width: 100%;
    height: 220px;
    object-fit: cover;
}

.user-img {
    position: relative;
    display: block;
    float: left;
}

.user-details {
    margin-left: 70px;
}

.separator {
    margin-top: 10px; 
    margin-bottom: 0px
}

</style>

<script>
import Star from '../place/Star'

export default {
    components: {
        Star
    },
    props: {
    },
    data() {
        return {

        }
    }
}
</script>